export default __webpack_public_path__ + "static/media/aws.116b0d26.png";